/**
 * Merger can be used for sending/updating items from one timeline instance
 * to another
 */
export default {
  methods: {
    // Add an entry to the timeline
    addTimelineEntry (otherTimeline, entries) {
      if (!Array.isArray(entries)) {
        entries = [entries]
      }
      otherTimeline.unshift(...entries)
    },
    // Update an existing entry on the timeline
    updateTimelineEntry (otherTimeline, updatedEntry) {
      // If the updated entry doesn't have a reference number, ignore
      if (!updatedEntry.timeline_reference) {
        return
      }

      // Remove entry from other timeline
      if (this.removeTimelineEntry(otherTimeline, updatedEntry.timeline_reference)) {
        // Re-add entry to other timeline
        this.addTimelineEntry(otherTimeline, updatedEntry)
      }
    },
    // (Un)pin an entry from the timeline
    pinTimelineEntry (otherTimeline, reference, isPinned) {
      if (!reference) {
        return false
      }

      // Try find the entry on the other timeline by reference
      const entry = otherTimeline.find(item => item.timeline_reference === reference)
      if (!entry) {
        return false
      }
      entry.timeline_pinned = isPinned
    },
    // Remove an entry from the timeline
    removeTimelineEntry (otherTimeline, reference) {
      if (!reference) {
        return false
      }

      // Try find the entry on the other timeline by reference
      const entry = otherTimeline.find(item => item.timeline_reference === reference)
      if (!entry) {
        return false
      }

      // Fetch index of entry in other timeline
      const index = otherTimeline.indexOf(entry)
      // Remove entry from other timeline
      otherTimeline.splice(index, 1)
      return true
    }
  }
}
